/* Global imports. */
import React from "react";

import {cleanStringForPath} from "@src/helpers"

interface Props {
  title: string;
  shortTitle: string;
}

function AnchorLinks({ title, shortTitle }: Props) {
  return (
    <div className="relative block clear-both w-full anchor-link">
      <h2 id={cleanStringForPath(shortTitle)}>{title}</h2>
    </div>
  );
}

export default AnchorLinks;
